// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.labelHolder_lkzk5 {
  display: grid;
  grid-template-columns: auto 1fr;  
  grid-template-rows: repeat( 2, 1fr );  
  grid-template-rows: repeat( var( --count-gridNumRows, 2 ), 1fr );
  grid-column-gap: 8px;
  grid-column-gap: var( --size-radioLabelSpace, 8px );
  -webkit-column-gap: 8px;
     -moz-column-gap: 8px;
          column-gap: 8px;
  -webkit-column-gap: var( --size-radioLabelSpace, 8px );
     -moz-column-gap: var( --size-radioLabelSpace, 8px );
          column-gap: var( --size-radioLabelSpace, 8px );
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.label_Vy87C {
  cursor: pointer;
}

.radioButton_K6qgf {
  cursor : pointer;
  position : relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.radioButton_K6qgf[disabled] {
  pointer-events: none;
}

/* Hide the browser's default radioButton*/ 
.radioButton_K6qgf input {
  position: absolute;
  opacity: 0;
  width : 0px;
  height : 0px;
  cursor: pointer;
}

.radioButton_K6qgf .appearance_g8DTw {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/RadioButton.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,oCAAgE;EAAhE,gEAAgE;EAChE,oBAA8C;EAA9C,mDAA8C;EAA9C,uBAA8C;KAA9C,oBAA8C;UAA9C,eAA8C;EAA9C,sDAA8C;KAA9C,mDAA8C;UAA9C,8CAA8C;EAC9C,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["\n.labelHolder {\n  display: grid;\n  grid-template-columns: auto 1fr;  \n  grid-template-rows: repeat( var( --count-gridNumRows, 2 ), 1fr );\n  column-gap: var( --size-radioLabelSpace, 8px );\n  align-items: center;\n}\n\n.label {\n  cursor: pointer;\n}\n\n.radioButton {\n  cursor : pointer;\n  position : relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n.radioButton[disabled] {\n  pointer-events: none;\n}\n\n/* Hide the browser's default radioButton*/ \n.radioButton input {\n  position: absolute;\n  opacity: 0;\n  width : 0px;\n  height : 0px;\n  cursor: pointer;\n}\n\n.radioButton .appearance {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelHolder": `labelHolder_lkzk5`,
	"label": `label_Vy87C`,
	"radioButton": `radioButton_K6qgf`,
	"appearance": `appearance_g8DTw`
};
export default ___CSS_LOADER_EXPORT___;
